import { render, staticRenderFns } from "./preheader.vue?vue&type=template&id=ecce1c58&scoped=true&"
import script from "./preheader.vue?vue&type=script&lang=js&"
export * from "./preheader.vue?vue&type=script&lang=js&"
import style0 from "./preheader.vue?vue&type=style&index=0&id=ecce1c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecce1c58",
  null
  
)

export default component.exports